import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiDateTimePickerDialogComponent } from './fi-date-time-picker-dialog/fi-date-time-picker-dialog.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiDateTimePickerDialogTimeInputComponent } from './fi-date-time-picker-dialog/fi-date-time-picker-dialog-time-input/fi-date-time-picker-dialog-time-input.component';

@NgModule({
    declarations: [FiDateTimePickerDialogComponent, FiDateTimePickerDialogTimeInputComponent],
    imports: [
        CommonModule,
        MatDatepickerModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        FormsModule,
        FiAppTextSharedModule,
        MatInputModule,
        MatDividerModule,
        FiValidatingFormModule,
    ],
    exports: [FiDateTimePickerDialogComponent],
})
export class FiDateTimePickerDialogModule {}
